const loadScript = (url: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        document.body.appendChild(script);
    });
};

// make sure this is a trusted source
const loadXhrScript = async (url: string, timeout:number): Promise<void> => {
    const timeoutPromise = new Promise<void>((_, reject) => setTimeout(() => reject('Failed to load script'), timeout));
    const loadPromise = new Promise<void>((resolve, reject) => {
        (async () => {
            const result = await fetch(url)
            if (result.status === 200) {
                const body = await result.text();
                window["eval"].call(window, body);
                resolve();
            } else {
                reject(new Error('Failed to load script'));
            }
        })();
    });

    return Promise.race([timeoutPromise, loadPromise]);
};


function isLoaded<T>({
    cond,
    delay,
    maxTries = 1000,
    doResolve,
}: {
    cond: () => boolean;
    delay: number;
    maxTries?:number;
    doResolve?: () => T;
}): Promise<T | null> {
    let attempts = 0;
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            attempts++;

            if(attempts >= maxTries){
                clearInterval(interval);
                reject('Maximum attempts reached');
            } else if (cond()) {
                clearInterval(interval);
                resolve(doResolve ? doResolve() : null);
            }
        }, delay);
    });
}

const reloadScript = (id: string, src: string, async: boolean) => {
    const oldScript = document.getElementById(id);
    if (oldScript != null) { oldScript.outerHTML = ""; }

    const s = document.getElementsByTagName("script")[0];
    const b = document.createElement("script");
    b.type = "text/javascript";
    b.async = async;
    b.src = src;
    b.id = id;
    s.parentNode?.insertBefore(b, s);
}

export { loadScript, isLoaded, reloadScript, loadXhrScript };
